export const ALLABOENDEN = 1;
export const ALLA_KOMMUNALA_BOENDEN = 2;
export const ALLA_LSS_BOENDEN = 3;
export const SPECIFIKA_BOENDEN = 4;